var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{class:['menu-list', { 'submenu-list': _vm.isSubmenuList }]},_vm._l((_vm.menu),function(item,index){return _c('aside-menu-item',{key:index,attrs:{"item":item},on:{"menu-click":function($event){return _vm.$emit('menu-click', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }